// extracted by mini-css-extract-plugin
module.exports = {"welcomeGallery":"style_welcomeGallery__iNIYG","welcomeGallerySlides":"style_welcomeGallerySlides__74lHU","sliderGalleryStory":"style_sliderGalleryStory__Vv2oM"};